import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    selector: String,
    scrollOnOpen: Boolean
  }

  show(event) {
    if (!this.targetElement) { return }

    this.targetElement.classList.add("element--on")
  }

  dismiss(event) {
    if (!this.targetElement) { return }

    this.targetElement.classList.remove("element--on")
  }

  toggle(event) {
    event.preventDefault()

    if (!this.targetElement) { return }

    if (this.targetElement.classList.contains("element--on")) {
      this.dismiss(event)
    } else {
      this.show(event)

      if (this.scrollOnOpenValue === true) {
        this.targetElement.scrollIntoView()
      }
    }
  }

  // Retrieves the target element using the selectorValue (which is expected to be an ID selector like "#elementId").
  // Since IDs that start with numbers (e.g. "#91A7C2") are not valid CSS selectors for querySelector,
  // we safely strip the leading "#" and use getElementById instead.
  get targetElement() {
    const id = this.selectorValue?.slice(1)
    if (/^\d/.test(id)) {
      return document.getElementById(id)
    }
    return document.querySelector(this.selectorValue)
  }
}
